module.exports = __webpack_public_path__ + "media/images/pro/main-00e775596e0917441944face2f171152.png";